<template>
  <div class="related-articles">
    <div class="related-articles__linebreak"></div>
    <h4>
      <TextHeading color="secondary" semi margin>Related articles</TextHeading>
    </h4>
    <a href="#" class="related-articles__wrapper">
      <img :src="getImage" alt="Alt description for the image">
      <div class="related-articles__info">
        Morrisons trials first plastic deposit return scheme in its supermarket.
        <span>30 Aug 2018</span>
      </div>
    </a>
    <a href="#" class="related-articles__wrapper">
      <img :src="getImage" alt="Alt description for the image">
      <div class="related-articles__info">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        <span>25 Dec 2018</span>
      </div>
    </a>
  </div>
</template>

<script>
import TextHeading from '../elements/TextHeading.vue'
export default {
  name: 'RelatedArticles',
  components: { TextHeading },
  props: {
    image: {
      type: String,
      default: 'article-pic.jpg'
    }
  },
  computed: {
    getImage() {
      return require('@/assets/images/' + this.image)
    }
  }
}
</script>

<style lang="postcss">
.related-articles {
  @apply w-full mt-8 mb-16 cursor-pointer;
}
.related-articles__wrapper {
  @apply flex items-center bg-secondary-lightest mb-2 no-underline text-body;
}
.related-articles__wrapper:hover {
  @apply bg-secondary-lighter;
}
.related-articles__wrapper img {
  @apply w-24 h-24;
  object-fit: cover;
}
.related-articles__info {
  @apply text-base font-semibold px-6 py-4 flex flex-col-reverse;
}
.related-articles__info span {
  @apply block font-normal text-xs text-secondary font-semibold tracking-wide my-0;
}
@screen md {
  .related-articles__info {
    @apply text-lg flex-col;
  }
  .related-articles__info span {
    @apply text-sm tracking-wide mt-1;
  }
  .related-articles__wrapper img {
    @apply w-32 h-32;
  }
}
@screen lg {
  .related-articles__linebreak {
    @apply py-4 border border-b-0 border-l-0 border-r-0 border-body-lighter;
  }
}
</style>
